import styled from "@emotion/styled";
import CloudOff from "@mui/icons-material/CloudOff";
import { Box, Typography } from "@mui/material";
import theme from "../theme";

export const BigCloudOff = styled(CloudOff)`
  width: 100px;
  height: 100px;
  color: ${theme.palette.primary.main};
`;

export const Overlay = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  z-index: 99999;
  align-items: center;
`;

export const Container = styled(Box)`
  justify-content: center;
  flex-direction: column;
  height: 100%;
  align-items: center;
  display: flex;
`;

export const NoSocketConnectionTitle = styled(Typography)`
  font-size: 24px;
  font-weight: bold;
  //margin-top: 64px;
  color: ${theme.palette.grey[800]};
`;

export const TapToConnect = styled(Typography)`
  font-size: 20px;
  margin-top: 20px;
  margin-bottom: 30px;
  font-weight: 500;
  color: ${theme.palette.grey[600]};
`;
